import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
    background: ${({theme}) => theme.colors.white};
    border: 1px solid ${({theme}) => theme.colors.stroke};
    box-sizing: border-box;
    box-shadow: ${({theme}) => theme.shadow.card};
    border-radius: ${({theme}) => theme.borderRadius.default};
`;
const GalleryHeader = styled.div`
    padding: 22px 0px;
    background: ${({theme}) => theme.colors.lightBlueOpacity};
    border-radius: 6px 6px 0px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    text-transform: uppercase;
`;
const GalleryBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px 35px;
`;
const Gallery = props => {
    return (
        <Wrapper
            width={props.width} 
            height={props.height}
        >
            <GalleryHeader>
                <label>{props.title}</label>
            </GalleryHeader>
            <GalleryBody>
                {props.children}
            </GalleryBody>
        </Wrapper>
    )
};

Gallery.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
};
export default Gallery;